import type {CSSAnimationKeyframes} from 'react-native-reanimated';

export const pulseKeyframes: CSSAnimationKeyframes = {
  from: {opacity: 1},
  '50%': {opacity: 0.4},
  to: {opacity: 1},
};

/** Pre-composed style object for direct application */
export const pulseStyle = {
  animationName: pulseKeyframes,
  animationDuration: '1.5s',
  animationTimingFunction: 'ease-in-out' as const,
  animationIterationCount: 'infinite' as const,
} as const;

/** Factory for pulse style with stagger delay */
export const createPulseStyle = (delayMs: number = 0) =>
  delayMs > 0 ? {...pulseStyle, animationDelay: `${delayMs}ms`} : pulseStyle;
